module.exports = __webpack_public_path__ + "img/successful2.33e95bab.png";